export function validateEmail(email = ''): boolean {
    return /.+@.+\..+/.test(email)
}

export function ruleIsEmail(email = ''): boolean | string {
    return validateEmail(email) || 'To pole jest wymagane'
}
